import React from 'react';
import { FormattedTextProps } from './FormattedText.types';
import { TextSpan } from './FormattedText.styles';

export const FormattedText: React.FC<FormattedTextProps> = ({
  children,
  className,
  style,
  ...props
}) => {
  if (typeof children !== 'string') {
    return null;
  }

  const formattedText = parseMarkdown(children);

  return (
    <span className={className} style={style} {...props}>
      {formattedText}
    </span>
  );
};

const parseMarkdown = (text: string) => {
  const output: React.ReactNode[] = [];
  let buffer = '';
  let isBold = false;
  let isItalic = false;
  let isUnderline = false;

  const flushBuffer = () => {
    if (buffer) {
      output.push(
        <TextSpan
          key={output.length}
          $isBold={isBold}
          $isItalic={isItalic}
          $isUnderline={isUnderline}
        >
          {buffer}
        </TextSpan>
      );
      buffer = '';
    }
  };

  // Helper function to toggle styles
  const toggleStyle = (tag: string) => {
    if (tag === '**' || tag === '<b>' || tag === '[b]' || tag === '</b>' || tag === '[/b]') {
      isBold = !isBold;
    }
    if (tag === '_' || tag === '<i>' || tag === '[i]' || tag === '</i>' || tag === '[/i]') {
      isItalic = !isItalic;
    }
    if (tag === '__' || tag === '<u>' || tag === '[u]' || tag === '</u>' || tag === '[/u]') {
      isUnderline = !isUnderline;
    }
  };

  const regex =
    /(\*\*|\[b\]|<\/b>|\[\/b\]|<b>|_|<\/i>|\[\/i\]|<i>|\[i\]|__|\[u\]|<\/u>|\[\/u\]|<u>)/g;
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    // Add text before the match to the buffer
    buffer += text.slice(lastIndex, match.index);
    flushBuffer(); // Flush the buffer to output with the current styles
    toggleStyle(match[0]); // Toggle the style based on the matched tag
    lastIndex = regex.lastIndex; // Update the last index to the end of the matched tag
  }

  // Add any remaining text after the last match to the buffer and flush
  buffer += text.slice(lastIndex);
  flushBuffer();

  return output;
};
